import { render } from "./LangCanvas.vue?vue&type=template&id=d476a852"
import script from "./LangCanvas.vue?vue&type=script&lang=js"
export * from "./LangCanvas.vue?vue&type=script&lang=js"

import exportComponent from "D:\\大众物流官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__